<script setup lang="ts">
import type { NovaBoxBoardListFaqItemProps } from './NovaBoxBoardListFaqItem.types'
import { ROUTES } from '@configs'

const props = defineProps<NovaBoxBoardListFaqItemProps>()

const route = useRoute()
const { date } = useDateFormat()
const { gtEvent } = useGoogleTag()

// FAQ 상세 라우터 이동
const goFaqDetail = () => {
  gtEvent('clickEvent', {
    eventCategory: '클릭',
    eventAction: '자주 묻는 질문 목록 > 상세보기',
    eventLabel: props.source.nttSj,
    eventSlot: '',
    eventI18nAddr: '',
    eventComponent: 'Button',
    nttClNm: props.source.nttClNm,
  })
  useNavigations({
    url: useRoutePathIdChange(ROUTES.BOARD_FAQ_DETAIL.path, {
      id: props.source.nttGroupId,
    }),
    query: route.query,
  })
}
</script>

<template>
  <button type="button" class="list-item" @click="goFaqDetail">
    <span class="title-box">
      <em class="title">[{{ source.nttClNm }}] {{ source.nttSj }}</em>
      <em class="date">
        {{ date({ date: source.sysRegistDt, format: 'YYYY-MM-DD' }) || '' }}
      </em>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.list-item {
  padding: 30px 20px;
  background-color: $color-white;
  border-radius: $radius-10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  width: 100%;

  .title-box {
    display: flex;
    flex-direction: column;
    gap: 6px;

    em {
      display: block;
      @include text-style($text-heading3-medium);
    }

    .title {
      @include ellipsis(1);
      text-align: left;
    }
    .date {
      @include text-style($text-body-12-regular);
      line-height: 14px;
      color: $color-text-3;
      text-align: left;
    }
  }
}
</style>
